import { IRequesterInfo } from "../../../../base/models"
import { ClientProxy } from "../../../../base/proxy/clientProxy"

export class SendDealerApprovalApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'MyReports/sendDealerApproval',
      requesterInfo,
    })
  }

  public async approveDealerApproval(request: number[]): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
